import React, { forwardRef } from "react";
import moment from "moment";
import { cloudFrontUrl } from "../nestserver";

const ApplicationFeeReceipt = forwardRef(
  ({ school, applicationNumber, studentName, amount, paymentDate }, ref) => (
    <div ref={ref} className="p-8">
      <div className="tc-doc">
        <div className="upper-part">
          <div className="relative w-20 h-20 rounded-full border-8 border-white">
            <img
              className="w-full h-full rounded-full border"
              src={
                school?.logo
                  ? `${cloudFrontUrl}/common/${school.logo}`
                  : "https://ui-avatars.com/api/?name=" +
                    (school?.name || "School")
              }
              alt="School logo"
            />
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-base font-semibold pb-1 capitalize">
              {school?.name}
            </p>
            <p className="text-sm capitalize">
              {school &&
                `${school.address || ""}, ${school.city || ""}, ${
                  school.state || ""
                } ${school.pincode || ""}`}
            </p>
            {school?.refId && (
              <p className="text-sm">
                <span className="font-semibold">Aff No./School Code:</span>{" "}
                {school.refId}
              </p>
            )}
          </div>
        </div>
      </div>

      <h3 className="text-xl font-semibold text-center pt-4 pb-6">
        Application Fee Receipt
      </h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          {[
            ["Application Number", applicationNumber],
            ["Student Name", studentName],
            ["Amount Paid", `₹${amount ?? 0}`],
            [
              "Payment Date",
              (paymentDate ? moment(paymentDate) : moment()).format(
                "DD-MM-YYYY"
              ),
            ],
            ["Status", "Paid"],
          ].map(([label, value]) => (
            <tr key={label}>
              <td
                style={{
                  padding: "0.5rem 0.75rem",
                  border: "1px solid #cbd5e1",
                  fontWeight: 600,
                  width: "40%",
                  background: "#f8fafc",
                }}
              >
                {label}
              </td>
              <td
                style={{
                  padding: "0.5rem 0.75rem",
                  border: "1px solid #cbd5e1",
                }}
              >
                {value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        className="flex justify-between items-end"
        style={{ marginTop: "3.5rem" }}
      >
        <p className="text-xs text-gray-500" style={{ maxWidth: "60%" }}>
          This receipt confirms payment of the application fee only and does
          not guarantee admission.
        </p>
        <div
          className="text-sm text-center"
          style={{
            borderTop: "1px solid #334155",
            paddingTop: "0.25rem",
            minWidth: "160px",
          }}
        >
          Authorized Signatory
        </div>
      </div>
    </div>
  )
);

export default ApplicationFeeReceipt;
